import { handleFilterChange } from 'lib/product';
import { SearchFacet, FacetValue } from 'lib/searchspring/client';
import { useRouter } from 'next/router';
import React, { ReactElement, useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Checkbox from '../Checkbox';
import MenuList, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core';

const StyledMenu = withStyles({
  paper: {
    padding: '0 0.5rem',
    borderRadius: '0.375rem',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%)',
    maxHeight: 400,
    minWidth: 180,
  },
})((props: MenuProps) => (
  <MenuList
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: -8,
      horizontal: 90,
    }}
    {...props}
  />
));

// styles for list item
const styles = makeStyles({
  root: {
    color: '#4a5568',
    '&:hover': {
      backgroundColor: 'rgb(var(--tertiary))',
      color: '#fff',
    },
    borderRadius: 4,
    '&.Mui-focusVisible': {
      backgroundColor: 'rgb(var(--tertiary))',
      color: '#fff',
    },
  },
  gutters: {
    padding: '0 8px',
  },
});

export default function Filter({ field, label, values }: SearchFacet): ReactElement {
  const router = useRouter();
  const selected = values.filter((value) => value.active);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = styles();

  const onChange = (facet: FacetValue): void => {
    const url = handleFilterChange(router.asPath, router.query, field, facet);
    router.push(url);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLLIElement>, value: FacetValue): void => {
    // Enter or Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      handleClose();
      onChange(value);
    }
  };

  return (
    <div className="relative inline-block text-left mt-4 ml-5">
      <button
        onClick={handleClick}
        aria-label={label + ' Filter'}
        className={`px-4 py-3 inline-flex justify-between rounded focus:outline-none ${
          selected.length > 0 ? 'has-selections' : 'border border-gray-400'
        }`}
        type="button"
        aria-haspopup={true}
        style={{ width: '180px' }}
      >
        {label} <KeyboardArrowDownIcon />
      </button>

      <StyledMenu
        tabIndex={0}
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        transitionDuration={200}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {values
          .sort((a, b) => (a.label >= b.label ? 1 : -1))
          .map((value, i) => (
            <MenuItem
              dense={true}
              role="option"
              key={value.label + i}
              onKeyDown={(e) => handleKeyPress(e, value)}
              aria-selected={value.active}
              classes={{ ...classes }}
            >
              <Checkbox
                field={field}
                filter={value}
                onChange={(value) => onChange(value)}
                isColor={label === 'Color'}
              />
            </MenuItem>
          ))}
      </StyledMenu>
    </div>
  );
}
